<template>
  <div>
    {{ venue.name || venueID || '' }}
  </div>
</template>

<script>

export default {
  data() {
    return {
      requestedVenueId: null,
    };
  },
  props: ["venueID"],
  computed: {
    venue() {
      const venue = this.$store.getters["venues/byId"](this.venueID);
      return venue || {};
    },
  },
  watch: {
    venueID: {
      immediate: true,
      handler(id) {
        this.ensureVenueLoaded(id);
      },
    },
  },
  methods: {
    ensureVenueLoaded(venueId) {
      if (venueId == null || venueId === '') return;
      const id = String(venueId);
      if (this.$store.getters["venues/byId"](id)) return;
      if (this.requestedVenueId === id) return;
      this.requestedVenueId = id;
      this.$store.dispatch("venues/fetchById", id).catch(() => {});
    },
  },
  components: {},
};
</script>

<style scoped>
/* 
.card{
  position: inherit;
} */
</style>
